function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.502 23.924c-2.828 2.525-6.815 3.614-10.732 2.556C-3.023 22.484 2.997-.168 17.79 3.827l.804-3.02C10.734-1.316 2.654 3.386.549 11.309-3.324 25.88 14.197 35.853 24.7 26.14l-2.197-2.215zm-6.59-9.162l-.782-8.99h-.776l-.775 9.772 7.399 6.449.549-.552-5.615-6.678zm10.813-2.846l1.498-.404a14.07 14.07 0 01-.844 9.619 13.986 13.986 0 01-1.037 1.849 14.11 14.11 0 01-1.14 1.495L24.1 23.363a12.41 12.41 0 001.877-2.901c.305-.656.556-1.348.748-2.072l.006.002a12.53 12.53 0 00-.006-6.476zm.133-6.59a4.565 4.565 0 00-2.409-4.032c.334.636.524 1.362.524 2.132 0 2.52-2.026 4.56-4.524 4.56a4.482 4.482 0 01-2.116-.527 4.52 4.52 0 004 2.428c2.5 0 4.525-2.042 4.525-4.56z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "29",
  height: "30"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.502 23.924c-2.828 2.525-6.815 3.614-10.732 2.556C-3.023 22.484 2.997-.168 17.79 3.827l.804-3.02C10.734-1.316 2.654 3.386.549 11.309-3.324 25.88 14.197 35.853 24.7 26.14l-2.197-2.215zm-6.59-9.162l-.782-8.99h-.776l-.775 9.772 7.399 6.449.549-.552-5.615-6.678zm10.813-2.846l1.498-.404a14.07 14.07 0 01-.844 9.619 13.986 13.986 0 01-1.037 1.849 14.11 14.11 0 01-1.14 1.495L24.1 23.363a12.41 12.41 0 001.877-2.901c.305-.656.556-1.348.748-2.072l.006.002a12.53 12.53 0 00-.006-6.476zm.133-6.59a4.565 4.565 0 00-2.409-4.032c.334.636.524 1.362.524 2.132 0 2.52-2.026 4.56-4.524 4.56a4.482 4.482 0 01-2.116-.527 4.52 4.52 0 004 2.428c2.5 0 4.525-2.042 4.525-4.56z",
  fill: "currentColor"
}))));